<template>
  <div class="suggestDetail">
    <Card>
      <h2 style="text-align: center;margin:20px 0 0 0;">建议详情</h2>
      <Divider/>
      <div style="width: 80%;margin: 0 auto">
        <el-descriptions class="margin-top" size="medium" :column="1" border
                         :labelStyle="{'text-align': 'center','width':'20%','color':'#555'}">
<!--          <el-descriptions-item label="openId">-->
<!--            {{ suggestInfo.openId }}-->
<!--          </el-descriptions-item>-->
          <el-descriptions-item label="联系电话">
            {{ suggestInfo.mobile }}
          </el-descriptions-item>
          <el-descriptions-item label="反馈内容">
            {{ suggestInfo.content }}
          </el-descriptions-item>
<!--          <el-descriptions-item label="图片">-->
<!--            {{ suggestInfo.img }}-->
<!--          </el-descriptions-item>-->
        </el-descriptions>

        <div style="text-align: center;margin-top: 10px">
          <Button type="primary" @click="goBack">返回</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: "suggestDetail",
  data() {
    return {
      suggestInfo: {}
    }
  },
  mounted() {
    if (this.$route.params.row) {
      this.suggestInfo = this.$route.params.row
    }
  },
  methods: {
    goBack(){
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'suggestFeedBack'
      })
    }
  }
}
</script>

<style scoped lang="less">
.suggestDetail {
}
</style>
